<template>
  <muziek />
</template>

<script>
import Muziek from '../components/OpbouwPlechtigheid/Muziek.vue'

export default {
  name: 'MuziekView',
  components: {
    Muziek
  }
}
</script>
